export const isDev = process.env.NODE_ENV === 'development';
export const isEmbedded = process.env.RENDER_MODE === 'embedded';
export const stagingEnvironment = process.env.STAGING_ENVIRONMENT ?? 'spark';
export const isOptOutEnabled = process.env.OPT_OUT_ENABLED === 'true';
